<template>
  <el-row type="flex" class="todo-service">
    <el-col>
      <div class="todo-customer-id">
        <span class="bold">{{ $t('idNumber') }}</span>: {{ service.id }}
      </div>
      <div class="todo-customer-name">
        <span class="bold">{{ $t('title') }}</span>: {{ service.service_title }}
      </div>
      <div class="todo-email">
        <span class="bold">{{ $t('price') }}</span>: ${{ service.price }}
      </div>
      <div class="todo-email">
        <span class="bold">{{ $t('date') }}</span>: {{ service.date_at }}
      </div>
      <div class="todo-email">
        <span class="bold">{{ $t('from') }}</span>: {{ service.time_from }} <span class="bold"> {{ $t('to') }}</span>: {{ service.time_to }}
      </div>
      <div class="todo-email">
        <span class="bold">{{ $t('created')}}</span>: {{ service.created_at | formatDate}}
      </div>
      <div class="todo-email">
        <span class="bold">{{ $t('updated') }}</span>: {{ service.created_at | formatDate }}
      </div>
    </el-col>
    <el-col class="text-right col-right">
      <div class="todo-customer-id">
        <span class="bold">{{ $t('consumer') }}</span>: {{ service.customer_profile.legal_name }}
      </div>
      <div class="todo-customer-id">
        {{ service.customer_profile.phone }}
      </div>
      <div class="todo-customer-id">
        <span class="bold">{{ $t('provider') }}</span>: {{ service.service.service_provider.name }}
      </div>
      <div class="todo-customer-id">
        {{ service.service.service_provider.phone }}
      </div>
      <div class="todo-email status">
        <span class="bold">{{ $t('status') }}</span>: {{ service.timeslot_type }}
      </div>
    </el-col>
  </el-row>
</template>

<script>

export default {
  props: {
    service: Object
  }
}
</script>

<style lang="scss">
@import '../../../assets/variables';

.todo-service {

  .bold {
    font-weight: bold;
  }

  .status {
    position: absolute;
    right: 0;
    bottom: 0;
    background-color: lightblue;
    padding: 10px;
    border-radius: 10px;
  }

  .todo-provider-service-type {
    color: $color-text-secondary;
  }

  .todo-provider-name {
    font-weight: bold;
    font-size: 18px;
    line-height: 34px;
    color: $color-text-regular;
  }

  .todo-provider-email {
    /* */
  }

  .edit-button{
    //width: 40px;
  }
  .todo-provider-date {
    font-size: 13px;
    color: $color-text-secondary;
  }

  .todo-provider-views {
    font-size: 13px;
    color: $color-text-secondary;

    span {
      font-weight: 600;
      font-size: 14px;
    }
  }

  .todo-provider-rating {
    font-weight: 500;
    font-size: 15px;
    line-height: 26px;
    color: $color-text-regular;

    .svg-icon {
      fill: $color-warning;
      color: $color-warning;
      vertical-align: middle;
      width: 18px;
      height: 18px;
      margin-left: 3px;
    }
  }
}
</style>
